import * as actionType from "./constants";

const initialState = {
    getStopLightColorDataResponse: {},
    updateStopLightColorResponse: { isLoading: false },
    addStopLightColorResponse: { isLoading: false },
    deleteStopLightColorResponse: { isLoading: false },
    getStopLightSystemDataResponse: {},
    updateStopLightSystemResponse: { isLoading: false },
    addStopLightSystemResponse: { isLoading: false },
    deleteStopLightSystemResponse: { isLoading: false }
};
export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.GET_STOP_LIGHT_COLOR_DATA_REQUEST:
            return {
                ...state,
                getStopLightColorDataResponse: { isLoading: true }
            };
        case actionType.GET_STOP_LIGHT_COLOR_DATA_SUCCESS:
            return {
                ...state,
                getStopLightColorDataResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.GET_STOP_LIGHT_COLOR_DATA_FAILURE:
            return {
                ...state,
                getStopLightColorDataResponse: { isLoading: false, success: false, ...action.error }
            };
        case actionType.UPDATE_STOP_LIGHT_COLOR_REQUEST:
            return {
                ...state,
                updateStopLightColorResponse: { isLoading: true }
            };
        case actionType.UPDATE_STOP_LIGHT_COLOR_SUCCESS:
            return {
                ...state,
                updateStopLightColorResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.UPDATE_STOP_LIGHT_COLOR_FAILURE:
            return {
                ...state,
                updateStopLightColorResponse: { isLoading: false, success: false, ...action.error }
            };

        case actionType.ADD_STOP_LIGHT_COLOR_REQUEST:
            return {
                ...state,
                addStopLightColorResponse: { isLoading: true }
            };
        case actionType.ADD_STOP_LIGHT_COLOR_SUCCESS:
            return {
                ...state,
                addStopLightColorResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.ADD_STOP_LIGHT_COLOR_FAILURE:
            return {
                ...state,
                addStopLightColorResponse: { isLoading: false, success: false, ...action.error }
            };
        case actionType.DELETE_STOP_LIGHT_COLOR_REQUEST:
            return {
                ...state,
                deleteStopLightColorResponse: { isLoading: true }
            };
        case actionType.DELETE_STOP_LIGHT_COLOR_SUCCESS:
            return {
                ...state,
                deleteStopLightColorResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.DELETE_STOP_LIGHT_COLOR_FAILURE:
            return {
                ...state,
                deleteStopLightColorResponse: { isLoading: false, success: false, ...action.error }
            };

        case actionType.GET_STOP_LIGHT_SYSTEM_DATA_REQUEST:
            return {
                ...state,
                getStopLightSystemDataResponse: { isLoading: true }
            };
        case actionType.GET_STOP_LIGHT_SYSTEM_DATA_SUCCESS:
            return {
                ...state,
                getStopLightSystemDataResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.GET_STOP_LIGHT_SYSTEM_DATA_FAILURE:
            return {
                ...state,
                getStopLightSystemDataResponse: { isLoading: false, success: false, ...action.error }
            };
        case actionType.UPDATE_STOP_LIGHT_SYSTEM_REQUEST:
            return {
                ...state,
                updateStopLightSystemResponse: { isLoading: true }
            };
        case actionType.UPDATE_STOP_LIGHT_SYSTEM_SUCCESS:
            return {
                ...state,
                updateStopLightSystemResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.UPDATE_STOP_LIGHT_SYSTEM_FAILURE:
            return {
                ...state,
                updateStopLightSystemResponse: { isLoading: false, success: false, ...action.error }
            };

        case actionType.ADD_STOP_LIGHT_SYSTEM_REQUEST:
            return {
                ...state,
                addStopLightSystemResponse: { isLoading: true }
            };
        case actionType.ADD_STOP_LIGHT_SYSTEM_SUCCESS:
            return {
                ...state,
                addStopLightSystemResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.ADD_STOP_LIGHT_SYSTEM_FAILURE:
            return {
                ...state,
                addStopLightSystemResponse: { isLoading: false, success: false, ...action.error }
            };
        case actionType.DELETE_STOP_LIGHT_SYSTEM_REQUEST:
            return {
                ...state,
                deleteStopLightSystemResponse: { isLoading: true }
            };
        case actionType.DELETE_STOP_LIGHT_SYSTEM_SUCCESS:
            return {
                ...state,
                deleteStopLightSystemResponse: { isLoading: false, success: true, ...action.response }
            };
        case actionType.DELETE_STOP_LIGHT_SYSTEM_FAILURE:
            return {
                ...state,
                deleteStopLightSystemResponse: { isLoading: false, success: false, ...action.error }
            };
        default:
            return state;
    }
};
